/**
 * Coarse relative time ("2m ago", "3h ago", "5d ago") for compact UI spots
 * where a full localized date/time would be too precise or too wide —
 * e.g. a last-sync timestamp on a tile or a "last changed" column.
 *
 * Deliberately NOT run through Transloco/transloco-locale: there's no
 * built-in relative-time pipe, and hand-rolling i18n for "m/h/d ago" across
 * languages isn't worth it for what's a secondary, at-a-glance value —
 * every call site also shows (or can show) the full ISO/localized timestamp
 * alongside or on hover for anyone who needs precision or their own locale.
 */
export function relativeTime(iso: string | null): string {
  if (!iso) return '—';
  const diffMs = Date.now() - new Date(iso).getTime();
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}
